"use client";

export default function Vision() {
  return (
    <section className="w-full bg-white py-12 md:py-16">
      <div className="max-w-[1900px] mx-auto px-6 md:px-12 xl:px-32 flex flex-col [@media(min-width:1026px)]:flex-row items-center justify-between gap-1 sm:gap-4 md:gap-7 lg:gap-10">
        {/* Left Heading */}
        <div className="flex justify-center lg:justify-start">
          <p
            className="
              text-3xl
              min-[341px]:text-4xl
              sm:text-4xl
              md:text-5xl
              xl:text-5xl
              tracking-wider
              leading-snug
              font-medium
              text-black
              font-[BOOWIE]
              text-center
              lg:text-left
            "
          >
            <span className="hidden sm:inline">
              ONE VISION - MANY VERTICALS
            </span>

            <span className="inline sm:hidden">
              ONE VISION <br /> MANY VERTICALS
            </span>
          </p>
        </div>

        {/* Right Description */}
        <div className="w-full [@media(min-width:1025px)]:w-1/2 flex justify-center [@media(min-width:930px)]:justify-end">
          <p className="mt-6 text-center text-base sm:text-lg md:text-xl text-[var(--secondary-text)] max-w-4xl text-justify">
            GITARTHA Global is a multi-vertical ecosystem built to support
            Business Growth, Governance, Infrastructure, Technology,
            Sustainability, Education, Wellness, and Essential Services. Each
            vertical operates independently with domain expertise, while
            remaining strategically integrated within the GITARTHA Ecosystem.
          </p>
        </div>
      </div>

      <div className="max-w-[1900px] mx-auto px-6 md:px-12 xl:px-32 mt-10">
        <div className="h-[4px] w-full bg-gradient-to-b from-[#CF973F] via-[#9D722C] to-[#FFD86D]"></div>
      </div>
    </section>
  );
}